var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M4.688 20.3a5.826 5.826 0 010-8.201l8.729-8.791a4.424 4.424 0 016.281 0 4.493 4.493 0 010 6.326l-7.35 7.402a3.114 3.114 0 01-4.42 0 3.163 3.163 0 010-4.451l6.225-6.269a.464.464 0 01.659 0l.658.663a.47.47 0 010 .663L9.245 13.91a1.277 1.277 0 000 1.799 1.259 1.259 0 001.787 0l7.35-7.402a2.61 2.61 0 000-3.674 2.57 2.57 0 00-3.649 0l-8.729 8.79a3.943 3.943 0 000 5.55 3.879 3.879 0 005.515-.001l7.6-7.657a.463.463 0 01.658 0l.658.663a.47.47 0 010 .663l-7.599 7.656a5.727 5.727 0 01-8.148.001z"
  }))));
}

export default SvgPaperclip;